export default "__VITE_ASSET__fd4ec529__"